
import SingleLineAddress from './SingleLineAddress.vue';
import SingleLineAddressBanner from './SingleLineAddressBanner.vue';
import { defineComponent } from 'vue';

const cssUrl = (document.currentScript as HTMLScriptElement).src.replace(/.js$/, '.css');

export default defineComponent({
  props: {
    setPropUpdaters: {
      type: Function,
      default: () => {},
    },
    initialProps: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return { ...this.initialProps };
  },
  components: {
    SingleLineAddress,
    SingleLineAddressBanner,
  },
  computed: {
    cssUrl: () => cssUrl,
  },
  mounted() {
    this.setPropUpdaters({
      layout: (value: string) => { this.layout = value; },
      target: (value: string) => { this.target = value; },
      type: (value: string) => { this.type = value; },
      logo: (value: boolean) => { this.logo = value; },
      platform: (value: string) => { this.platform = value; },
      floatingButton: (value: string) => { this.floatingButton = value; },
      noFloatingButton: (value: boolean) => { this.noFloatingButton = value; },
      mTracking: (value: string) => { this.mTracking = value; },
    });
  },
});
